var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "480px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary",
            "fab": "",
            "fixed": "",
            "right": "",
            "bottom": "",
            "dark": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-pencil")])], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "light": ""
    }
  }, [_c('v-card-title', [_vm._v("회원 추가")]), _c('v-divider'), _c('v-card-text', {
    staticClass: "pa-6"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "아이디"
    },
    model: {
      value: _vm.inputs.username,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "username", $$v);
      },
      expression: "inputs.username"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "비밀번호",
      "type": "password"
    },
    model: {
      value: _vm.inputs.password,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "password", $$v);
      },
      expression: "inputs.password"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', _vm._b({
    attrs: {
      "items": _vm.userTypes,
      "label": "유형"
    },
    model: {
      value: _vm.inputs.type,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "type", $$v);
      },
      expression: "inputs.type"
    }
  }, 'v-select', _vm.inputProps, false))], 1), _vm.isIndividual ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', _vm._b({
    attrs: {
      "items": _vm.individualKinds,
      "label": "유형"
    },
    model: {
      value: _vm.inputs.kind,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "kind", $$v);
      },
      expression: "inputs.kind"
    }
  }, 'v-select', _vm.inputProps, false))], 1) : _vm._e(), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', _vm._b({
    attrs: {
      "label": "가입 승인",
      "dense": false
    },
    model: {
      value: _vm.inputs.isApproval,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "isApproval", $$v);
      },
      expression: "inputs.isApproval"
    }
  }, 'v-switch', _vm.inputProps, false))], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', _vm._b({
    attrs: {
      "label": "전문기업 승인",
      "dense": false
    },
    model: {
      value: _vm.inputs.isExpert,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "isExpert", $$v);
      },
      expression: "inputs.isExpert"
    }
  }, 'v-switch', _vm.inputProps, false))], 1)], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }